import React, { useEffect } from "react";
import { usePageMeta } from "@/lib/usePageMeta";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  usePageMeta({ noindex: true });
  const nav = useNavigate();
  const { user, loading } = useAuth();

  // Supabase finishes the OAuth callback inside AuthContext; wait for it to
  // settle, then navigate exactly once. (A polling loop used to fire a second,
  // stale redirect to "/" two seconds after landing on /profile.)
  useEffect(() => {
    if (!loading) nav(user ? "/profile" : "/", { replace: true });
  }, [loading, user, nav]);

  return (
    <div className="min-h-[50vh] flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="text-sm text-muted-foreground mt-3">Signing you in…</p>
      </div>
    </div>
  );
}
